<template>
  <div>
    <PageLoader :storage="appLoading" />
    <v-dialog v-model="transferDialogue" width="400">
      <v-card>
        <v-layout v-if="socketData" pa-4 wrap justify-center>
          <v-flex xs12 v-if="socketData.transferData">
            <span
              v-if="socketData.transferData.transferredBy"
              style="
                color: #000000;
                font-family: sofiaProSemibold;
                font-size: 18px;
              "
            >
              A New Transfer case request from
              {{ socketData.transferData.transferredBy.fullName }}
            </span>
          </v-flex>

          <v-flex xs6 px-2 py-4>
            <v-btn
              outlined
              tile
              block
              depressed
              dark
              :color="appColor"
              @click="transferDialogue = false"
              class="itemValue"
            >
              Cancel
            </v-btn>

            <!-- @click="activateUser" -->
          </v-flex>
          <!-- <v-flex xs6 px-2 py-4>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1FB436"
              @click="transferDialogue = false"
              class="itemValue"
            >
              close
            </v-btn>
          </v-flex> -->
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex xs12 md5>
        <v-layout
          wrap
          v-for="(item, i) in storage"
          @click="clickItem(item)"
          :key="i"
          class="wwCaseCard"
          :class="item.status == 'Pending' ? 'wwCaseCard--pending' : ''"
        >
          <!-- <v-flex  v-if="item.status=='Pending'==playSound(
              'http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3'
          )">
          
            </v-flex> -->
          <v-flex
            xs3
            sm2
            md3
            lg2
            xl2
            :class="
              $vuetify.breakpoint.name == 'xs' ||
              $vuetify.breakpoint.name == 'sm'
                ? 'text-center'
                : 'text-left'
            "
            align-self-center
          >
            <div class="wwThumb">
              <img
                v-if="item && item.reportImages && item.reportImages.length > 0"
                alt="Report"
                :src="mediaURL + item.reportImages[0]"
              />
              <div v-else class="wwThumbEmpty" title="No image available">
                <v-icon size="20" class="wwThumbEmptyIcon"
                  >mdi-image-off-outline</v-icon
                >
                <span class="wwThumbEmptyText">No image</span>
              </div>
            </div>
          </v-flex>
          <v-flex xs9 sm10 md9 lg10 xl10 class="pl-2">
            <v-layout wrap>
              <v-flex v-if="item && item.scenarioId" xs6 sm3 md3 lg9>
                <v-btn
                  x-small
                  depressed
                  class="py-2"
                  :outlined="item.status == 'Pending' ? true : false"
                  :ripple="false"
                  :color="item.status == 'Pending' ? '#deb710' : '#F5F5F5'"
                  style="letter-spacing: 0px"
                  ><span
                    style="
                      font-family: sofiaProRegular;
                      color: #000;
                      font-size: 8px;
                    "
                    >{{ item.scenarioId.name }}
                  </span></v-btn
                >
              </v-flex>
              <v-flex xs4 sm3 md3 lg3 text-right>
                <span
                  class="text-uppercase"
                  style="
                    font-family: sofiaProRegular;
                    color: #deb710;
                    font-size: 8px;
                  "
                >
                  {{ item.statuscopy }}</span
                >
              </v-flex>

              <!-- hii{{ socketType }}<br />
              reportid{{ item._id }}<br />
              {{socketData}}
              socketid{{ socketData._id }}<br />
              id{{ $route.query.id }} -->

              <v-flex
                v-if="item.isAssignedToMe && appUser == 'official'"
                xs4
                sm3
                md3
                text-left
              >
                <span
                  class="text-uppercase"
                  style="
                    font-family: sofiaProRegular;
                    color: #deb710;
                    font-size: 8px;
                  "
                >
                  Assigned to you</span
                >
              </v-flex>
              <v-flex v-if="item.isTransferred" text-right xs4 sm3 md3>
                <span
                  class="text-uppercase"
                  style="
                    font-family: sofiaProRegular;
                    color: #deb710;
                    font-size: 8px;
                  "
                >
                  Transffered</span
                >
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs8 sm7 md8 lg8 xl8>
                <span class="itemHeading" v-if="item && item.animalId && item.animalId.name">
                  {{ item.animalId.name }}
                </span>
                <span class="itemHeading" v-else>
                  Unknown
                </span>
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 xl4 text-right>
                <span
                  style="
                    font-family: sofiaProRegular;
                    color: #000;
                    font-size: 10px;
                  "
                >
                  {{ timeSince(item.update_date) }}
                  <!-- <timeago :datetime="item.create_date" :auto-update="60"></timeago> -->
                </span>
              </v-flex>
              <v-flex xs12 pt-1>
                <div class="wwInfoGrid">
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--threat"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="wwInfoLabel">Threat Level</span>
                    <span
                      v-if="item.threatlevel"
                      class="wwThreat"
                      :class="threatClass(item.threatlevel)"
                      >{{ formatText(item.threatlevel) }}</span
                    >
                    <span v-else class="wwInfoValue wwMuted">Unknown</span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--location"
                      >mdi-map-marker-outline</v-icon
                    >
                    <span class="wwInfoLabel">Location</span>
                    <span v-if="item.locationname" class="wwInfoValue">{{
                      formatText(item.locationname)
                    }}</span>
                    <span v-else class="wwInfoValue wwMuted">Unknown</span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--time">mdi-clock-outline</v-icon>
                    <span class="wwInfoLabel">Reported</span>
                    <span v-if="item.reportTime" class="wwInfoValue">{{
                      formatReportTime(item.reportTime)
                    }}</span>
                    <span v-else class="wwInfoValue wwMuted">Unknown</span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--person"
                      >mdi-account-outline</v-icon
                    >
                    <span class="wwInfoLabel">Sighted By</span>
                    <span class="wwInfoValue">
                      <span v-if="item && item.addedBy && item.addedBy.role">
                        <span v-if="item.addedBy.role === 'User'">
                          <span v-if="item.addedBy.userId">{{
                            item.addedBy.userId.name
                          }}</span>
                        </span>
                        <span v-if="item.addedBy.role === 'MASTER'">
                          <span v-if="item.addedBy.admin">{{
                            item.addedBy.admin.masterName
                          }}</span>
                        </span>
                        <span v-if="item.addedBy.role === 'EmergencyUser'">
                          <span v-if="item.addedBy.userId">{{
                            item.addedBy.userId.name
                          }}</span>
                        </span>
                        <span v-if="item.addedBy.role === 'RANGE'">
                          <span
                            v-if="
                              item.addedBy.range &&
                              item.addedBy.range.accessCredentials
                            "
                            >{{
                              item.addedBy.range.accessCredentials.username
                            }}</span
                          >
                        </span>
                        <span v-if="item.addedBy.role === 'DIVISION'">
                          <span
                            v-if="
                              item.addedBy.division &&
                              item.addedBy.division.accessCredentials
                            "
                            >{{
                              item.addedBy.division.accessCredentials.username
                            }}</span
                          >
                        </span>
                        <span v-if="item.addedBy.role === 'RRT'">
                          <span
                            v-if="item.addedBy.userId && item.addedBy.userId.name"
                            >{{ item.addedBy.userId.name }}</span
                          >
                        </span>
                        <span v-if="item.addedBy.role === 'DEOC'">
                          <span
                            v-if="item.addedBy.userId && item.addedBy.userId.name"
                            >{{ item.addedBy.userId.name }}</span
                          >
                        </span>
                        <span v-if="item.addedBy.role === 'Rescuer'">
                          <span v-if="item.addedBy.role">{{
                            item.addedBy.role
                          }}</span>
                        </span>
                        <span
                          v-if="
                            item.addedBy.role === 'EmergencyUser' &&
                            !item.addedBy.userId
                          "
                          >Emergency User</span
                        >
                      </span>
                      <span v-else class="wwMuted">Unknown</span>
                    </span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--division"
                      >mdi-office-building-outline</v-icon
                    >
                    <span class="wwInfoLabel">Division</span>
                    <span v-if="deocDivisionName(item)" class="wwInfoValue">{{
                      deocDivisionName(item)
                    }}</span>
                    <span v-else class="wwInfoValue wwMuted">Not available</span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--deoc"
                      >mdi-shield-account-outline</v-icon
                    >
                    <span class="wwInfoLabel">DEOC</span>
                    <span v-if="deocName(item)" class="wwInfoValue">
                      {{ deocName(item)
                      }}<template v-if="deocPhone(item)">
                        &middot;
                        <a
                          :href="'tel:' + deocPhone(item)"
                          class="wwPhone"
                          @click.stop
                          >{{ deocPhone(item) }}</a
                        ></template
                      >
                    </span>
                    <span v-else class="wwInfoValue wwMuted">Not assigned</span>
                  </div>
                  <div class="wwInfoRow">
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--phone">mdi-phone-outline</v-icon>
                    <span class="wwInfoLabel">Phone Number</span>
                    <a
                      v-if="isDialable(item.contactNumber)"
                      :href="'tel:' + item.contactNumber"
                      class="wwInfoValue wwPhone"
                      @click.stop
                      >{{ item.contactNumber }}</a
                    >
                    <span v-else-if="item.contactNumber" class="wwInfoValue">{{
                      item.contactNumber
                    }}</span>
                    <span v-else class="wwInfoValue wwMuted">Not available</span>
                  </div>
                  <div
                    class="wwInfoRow"
                    v-if="
                      item &&
                      item.isVerifiedBy &&
                      item.isVerifiedBy.isReportVerified
                    "
                  >
                    <v-icon size="15" class="wwInfoIcon wwInfoIcon--ok"
                      >mdi-check-decagram-outline</v-icon
                    >
                    <span class="wwInfoLabel">Verified By</span>
                    <span class="wwInfoValue">
                      <span v-if="item.isVerifiedBy.role">
                        <span v-if="item.isVerifiedBy.role === 'DEOC'">
                          <span v-if="item.isVerifiedBy.userId"
                            >{{ item.isVerifiedBy.userId.username }} ({{
                              item.isVerifiedBy.role
                            }})</span
                          >
                        </span>
                        <span v-if="item.isVerifiedBy.role === 'division'">
                          <span
                            v-if="
                              item.isVerifiedBy.division &&
                              item.isVerifiedBy.division.divisionName
                            "
                            >{{ item.isVerifiedBy.division.divisionName }}</span
                          >
                        </span>
                      </span>
                      <span v-else class="wwMuted">Unknown</span>
                    </span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 pt-3>
                <v-btn
                  width="100%"
                  depressed
                  small
                  height="34"
                  class="wwActionBtn"
                  color="#2e6b3f"
                  @click="
                    $router.push('/Admin/cases/caseDetails/?id=' + item._id) &&
                      checkSound(item)
                  "
                >
                  <span v-if="item.status == 'Pending'">Take Action</span>
                  <span v-else>View Details</span>
                  <v-icon size="15" class="pl-2">mdi-arrow-right</v-icon>
                </v-btn>
              </v-flex>
              <!-- <v-flex xs12 sm9 md12 lg12 xl2 pt-1>
                <v-btn
                  width="100%"
                  shaped
                  small
                  color="#000000"
                  @click="confirmDelete(item._id)"
                >
                  <span style="color: #fff; font-size: 10px">Delete Case</span>

                  <v-icon
                    style="
                      font-family: sofiaProRegular;
                      color: #ffffff;
                      font-size: 14px;
                    "
                    class="pl-3"
                    >mdi-delete
                  </v-icon>
                </v-btn>
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12 v-if="caseMsg" text-center>
        <span style="fonr-family: sofiaProBold; font-size: 18px"
          >No Data Found</span
        >
      </v-flex> -->
      <v-flex xs12 md7>
        <div class="posSticky wwMapShell">
          <div id="map"></div>
          <div class="wwLegend">
            <span class="wwLegendTitle">Threat</span>
            <span class="wwLegendItem"
              ><i class="wwLegendDot" style="background: #b3261e"></i>High</span
            >
            <span class="wwLegendItem"
              ><i class="wwLegendDot" style="background: #c9930a"></i
              >Medium</span
            >
            <span class="wwLegendItem"
              ><i class="wwLegendDot" style="background: #22683a"></i>Low</span
            >
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Delete Case</v-card-title>
        <v-card-text> Are you sure you want to delete this case? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteCase">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import axios from "axios";
import Socket from "./../../../Sockets/socket";
import deocInfo from "@/mixins/deocInfo";

var audio;
// import io from "socket.io-client";
export default {
  mixins: [deocInfo],
  props: ["authentication", "storage", "pageType"],
  data() {
    return {
      appLoading: false,
      map: "",
      caseDetails: [],
      isConnected: false,
      isConnected1: "hu",
      name: "Bob",
      message: "click on the buttons",
      socketType: null,
      socketData: {},
      infoItem: null,
      caseMsg: null,
      content: null,
      transferDialogue: false,
      infowindow: null,
      dialog: false,
      markers: [], // Array to hold markers
      infowindows: [], // Array to hold info windows
    };
  },

  computed: {
    myData() {
      if (this.storage.length > 0) return this.storage;
      else return [];
    },
    dataLength() {
      return this.len;
    },
    appUser() {
      return this.$store.state.userData;
    },
    // authValue()
    // {
    //   return this.$store.state.authentication
    // }
  },
  // beforeMount() {
  //   setInterval(() => {
  //   this.getData();
  //   this.getresolveData();
  //   window.location.reload();
  // }, 10000);
  // },
  mounted() {
    this.loadData();
    window.addEventListener("resize", this.handleResize);
    // if (!this.$route.query.id || this.$route.query.id == "activeCases")
    // this.getSocketData();
    // this.socketAuth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    storage: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    socketType() {
      // if(this.socketType == "newConflict")
      //   {
      //    if (this.socketData.status == "Pending") {
      //     this.playSound(require("../../../assets/audios/alarm.mp3"));
      //   }
      //   }
      if (
        this.socketType == "newConflict" &&
        (!this.$route.query.id || this.$route.query.id == "activeCases")
      ) {
        if (this.socketData.status == "Pending") {
          this.playSound(require("../../../assets/audios/alarm.mp3"));
        }
        // this.transferDialogue=true
        this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
        // Redraw so the incoming conflict gets a pin; pending pins pulse via CSS.
        this.$nextTick(() => {
          this.initMap();
        });
        // this.socketData = {};
      }
      if (this.socketType == "reportClose") {
        if (
          !this.$route.query.id ||
          this.$route.query.id == "activeCases" ||
          this.$route.query.id == "assignedCases"
        ) {
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id)
              this.caseDetails.splice(i, 1);
          }
        } else if (this.$route.query.id == "resolvedCases") {
          console.log("returm", this.changeCaseDetails(this.socketData));
          this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          this.socketData = {};
        }
      }

      if (this.socketType == "reportAssign") {
        if (!this.$route.query.id || this.$route.query.id == "activeCases") {
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id)
              this.caseDetails.splice(i, 1);
          }
        } else if (this.$route.query.id == "assignedCases") {
          this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          this.socketData = {};
        }
      }
      if (this.socketType == "reportCapture") {
        if (this.$route.query.id == "assignedCases") {
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id)
              this.caseDetails.splice(i, 1);
          }
        } else if (this.$route.query.id == "capturedCases") {
          this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          this.socketData = {};
        }
      }
      if (this.socketType == "reportRelease") {
        if (this.$route.query.id == "capturedCases") {
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id)
              this.caseDetails.splice(i, 1);
          }
        } else if (this.$route.query.id == "resolvedCases") {
          this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          this.socketData = {};
        }
      }
      if (this.socketType == "reportResolve") {
        if (this.$route.query.id == "assignedCases") {
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id)
              this.caseDetails.splice(i, 1);
          }
        } else if (this.$route.query.id == "resolvedCases") {
          this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          this.socketData = {};
        }
      }
      if (this.socketType == "reportLocationUpdate") {
        if (this.$route.query.id == "assignedCases") {
          var flag = 0;
          for (let i = 0; i < this.caseDetails.length; i++) {
            if (this.caseDetails[i]._id == this.socketData._id) flag = 1;
          }
          if (flag == 0) {
            this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
            this.socketData = {};
          }
        }
      }
      if (this.socketType == "reportTransferRequest") {
        if (this.$route.query.id == "assignedCases") {
          // this.caseDetails.unshift(this.changeCaseDetails(this.socketData));
          // this.socketData = {};
          this.transferDialogue = true;
        }
      }
    },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
  methods: {
    formatText(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    // Keltron sends "Unknown number" when it has no number for the caller,
    // so only turn genuinely numeric values into a tel: link.
    isDialable(value) {
      if (!value) return false;
      return /^\+?[\d\s-]{6,}$/.test(String(value).trim());
    },
    threatClass(level) {
      var key = String(level || "").toLowerCase();
      if (key === "low" || key === "medium" || key === "high") {
        return "wwThreat--" + key;
      }
      return "wwThreat--unknown";
    },
    confirmDelete(caseId) {
      this.caseToDelete = caseId;
      this.dialog = true;
    },
    formatReportTime(dateString) {
      const date = new Date(dateString);
      const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      });
      const formattedDate = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC",
      });
      return `${time} ${formattedDate}`;
    },
    clickItem(item) {
      const markerIndex = this.caseDetails.indexOf(item);
      const target = this.markers[markerIndex];
      if (markerIndex === -1 || !target || !this.map) return;
      this.map.panTo(target.getLatLng());
      target.openPopup();
    },
    changeCaseDetails(caseData) {
      if (caseData.reportImages.length > 0)
        caseData.image = caseData.reportImages[0];
      else caseData.image = "noimage.jpg";
      //if (!caseData.userId.fullName) caseData.userId.fullName = "Unknown";
      if (!caseData.address) caseData.address = "Unknown Address";

      return caseData;
    },

    checkSound(item) {
      if (item._id == this.socketData._id) {
        audio.loop = false;

        audio.pause();
      }
    },
    handleResize() {
      if (this.map && this.map.invalidateSize) {
        this.map.invalidateSize();
      }
    },
    loadData() {
      this.caseDetails = this.myData;
      for (let i = 0; i < this.caseDetails.length; i++) {
        this.caseDetails[i].image = null;
        if (this.caseDetails[i].reportImages.length > 0)
          this.caseDetails[i].image = this.caseDetails[i].reportImages[0];
        else this.caseDetails[i].image = "";
        if (!this.caseDetails[i].address)
          this.caseDetails[i].address = "Unknown Address";
      }
      this.$nextTick(() => {
        this.initMap();
      });
    },
    // clickItem(item) {
    //   // this.infoItem = item;
    //   for (var i = 0; i < this.storage.length; i++) {
    //     if (this.storage[0]._id == item._id) {
    //       infowindow.open(map, marker);
    //     }
    //   }
    // },
    playSound(sound) {
      if (sound) {
        audio = new Audio(sound);
        if (this.socketData.status == "Pending") {
          audio.play();
          audio.loop = true;
        } else {
          audio.pause();
          audio.loop = false;
        }
      }
    },
    getSocketData() {
      Socket.dataFunction(this); // <---read data
    },
    // socketAuth() {
    //   Socket.authFunction(this); // <---read data
    // },
    infoWIndow() {},
    //   initMap() {
    //   const mapCanvas = document.getElementById("map");
    //   if (!mapCanvas) return;

    //   const defaultLocation = { lat: 0, lng: 0 }; // Default location if caseDetails is empty

    //   const mapOptions = {
    //     center: new google.maps.LatLng(
    //       this.caseDetails[0]?.location[1] || defaultLocation.lat,
    //       this.caseDetails[0]?.location[0] || defaultLocation.lng
    //     ),
    //     zoom: 7,
    //   };
    //   this.map = new google.maps.Map(mapCanvas, mapOptions);

    //   // Clear existing markers and infowindows
    //   this.markers.forEach((marker) => marker.setMap(null));
    //   this.infowindows.forEach((infowindow) => infowindow.close());

    //   this.markers = [];
    //   this.infowindows = [];

    //   // Add markers and info windows
    //   this.caseDetails.forEach((item) => {
    //     const position = new google.maps.LatLng(item.location[1], item.location[0]);
    //     const marker = new google.maps.Marker({
    //       position,
    //       map: this.map,
    //       title: `Case ID: ${item._id}`,
    //     });

    //     const infowindow = new google.maps.InfoWindow({
    //       content: `
    //         <div style="width: 400px; height: 210px;">
    //               <div class="xs12 flex">
    //                 <h2 style="font-family: sofiaProMedium;">${item.animalId.name}</h2>
    //                 </div><br>
    //               <div class="xs12 flex">
    //                 <p><span style="font-size: 13px;font-family: sofiaProMedium;">Location Name:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.locationname}</span></p>
    //                 <p><span style="font-size: 13px;font-family: sofiaProMedium;">Coordinates:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.location[1]}, ${item.location[0]}</span></p>
    //                 <p><span style="font-size: 13px;font-family: sofiaProMedium;">Threat Level:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.threatlevel}</span></p>
    //                 <p><span style="font-size: 13px;font-family: sofiaProMedium;">Status:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.status}</span></p>
    //               </div>
    //                         <div class="xs12 flex">
    //               <div class="layout wrap">
    //                 <div class="flex xs5 text-left">
    //                   <span class="itemKey text-capitalize v-btn--active v-btn v-btn--has-bg v-btn--router theme--light v-size--medium"
    //                     style="background-color: #FF6907;">
    //                     <span class="v-btn__content py-2 px-3">
    //                       <i style="color:#FFF;font-size:18px;" class="fas fa-location-arrow"></i>
    //                       <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #FFF;"> Direction</span>
    //                     </span>
    //                   </span>
    //                 </div>
    //                 <div class="flex xs4 text-left">
    //                   <span class="itemKey text-capitalize v-btn v-btn--router v-btn-outlined theme--light v-size--medium"
    //                     style="background-color: #FFF; border:.5px solid #EAEAEA; cursor:pointer">
    //                     <span class="v-btn__content py-2 px-3">
    //                       <i style="color:#000;font-size:18px;" class="fas fa-phone-alt"></i>
    //                       <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #000;"> Call</span>
    //                     </span>
    //                   </span>
    //                 </div>
    //                 <div class="flex xs3 text-left">
    //                   <span class="itemKey text-capitalize v-btn v-btn--router v-btn-outlined theme--light v-size--medium"
    //                     style="background-color: #FFF; border:.5px solid #EAEAEA; cursor:pointer">
    //                     <span class="v-btn__content py-2 px-3">
    //                       <i style="color:#000;font-size:18px;" class="fas fa-share-alt"></i>
    //                       <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #000;"> Share</span>
    //                     </span>
    //                   </span>
    //                 </div>
    //               </div>
    //             </div>
    //             </div>
    //       `,
    //     });

    //     marker.addListener("click", () => {
    //       this.infowindows.forEach((info) => info.close());
    //       infowindow.open(this.map, marker);
    //     });

    //     this.markers.push(marker);
    //     this.infowindows.push(infowindow);
    //   });
    // },
    //   initMap() {
    //   const mapCanvas = document.getElementById("map");
    //   if (!mapCanvas) return;

    //   const defaultLocation = { lat: 0, lng: 0 }; // Default location if caseDetails is empty

    //   const mapOptions = {
    //     center: new google.maps.LatLng(
    //       this.caseDetails[0]?.location[1] || defaultLocation.lat,
    //       this.caseDetails[0]?.location[0] || defaultLocation.lng
    //     ),
    //     zoom: 7,
    //   };
    //   this.map = new google.maps.Map(mapCanvas, mapOptions);

    //   // Clear existing markers and infowindows
    //   this.markers.forEach((marker) => marker.setMap(null));
    //   this.infowindows.forEach((infowindow) => infowindow.close());

    //   this.markers = [];
    //   this.infowindows = [];

    //   // Define icon URLs for different threat levels
    //   const icons = {
    //     High: require('@/assets/images/highthreat.png'),
    //     Medium: require('@/assets/images/mediumthreat.png'),
    //     Low: require('@/assets/images/lowthreat.png')
    //   };

    //   // Add markers and info windows
    //   this.caseDetails.forEach((item) => {
    //     const position = new google.maps.LatLng(item.location[1], item.location[0]);

    //     // Determine the icon based on threat level
    //     const icon = icons[item.threatlevel] || icons['Low']; // Default to Low if threatlevel is not defined

    //     const marker = new google.maps.Marker({
    //       position,
    //       map: this.map,
    //       title: `Threat Level: ${item.threatlevel}`,
    //       icon: icon, // Set the icon based on threat level
    //     });

    //     const infowindow = new google.maps.InfoWindow({
    //       content: `
    //         <div style="width: 400px; height: 210px;">
    //           <div class="xs12 flex">
    //             <h2 style="font-family: sofiaProMedium;">${item.animalId.name}</h2>
    //           </div><br>
    //           <div class="xs12 flex">
    //             <p><span style="font-size: 13px;font-family: sofiaProMedium;">Location Name:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.locationname}</span></p>
    //             <p><span style="font-size: 13px;font-family: sofiaProMedium;">Coordinates:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.location[1]}, ${item.location[0]}</span></p>
    //             <p><span style="font-size: 13px;font-family: sofiaProMedium;">Threat Level:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.threatlevel}</span></p>
    //             <p><span style="font-size: 13px;font-family: sofiaProMedium;">Status:</span><span style="font-size: 12px;font-family: sofiaProMedium;"> ${item.status}</span></p>
    //           </div>
    //           <div class="xs12 flex">
    //             <div class="layout wrap">
    //               <div class="flex xs5 text-left">
    //                 <span class="itemKey text-capitalize v-btn--active v-btn v-btn--has-bg v-btn--router theme--light v-size--medium"
    //                   style="background-color: #FF6907;">
    //                   <span class="v-btn__content py-2 px-3">
    //                     <i style="color:#FFF;font-size:18px;" class="fas fa-location-arrow"></i>
    //                     <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #FFF;"> Direction</span>
    //                   </span>
    //                 </span>
    //               </div>
    //               <div class="flex xs4 text-left">
    //                 <span class="itemKey text-capitalize v-btn v-btn--router v-btn-outlined theme--light v-size--medium"
    //                   style="background-color: #FFF; border:.5px solid #EAEAEA; cursor:pointer">
    //                   <span class="v-btn__content py-2 px-3">
    //                     <i style="color:#000;font-size:18px;" class="fas fa-phone-alt"></i>
    //                     <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #000;"> Call</span>
    //                   </span>
    //                 </span>
    //               </div>
    //               <div class="flex xs3 text-left">
    //                 <span class="itemKey text-capitalize v-btn v-btn--router v-btn-outlined theme--light v-size--medium"
    //                   style="background-color: #FFF; border:.5px solid #EAEAEA; cursor:pointer">
    //                   <span class="v-btn__content py-2 px-3">
    //                     <i style="color:#000;font-size:18px;" class="fas fa-share-alt"></i>
    //                     <span class="pl-1" style="font-family: sofiaProMedium;font-size:16px;color: #000;"> Share</span>
    //                   </span>
    //                 </span>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       `,
    //     });

    //     marker.addListener("click", () => {
    //       this.infowindows.forEach((info) => info.close());
    //       infowindow.open(this.map, marker);
    //     });

    //     this.markers.push(marker);
    //     this.infowindows.push(infowindow);
    //   });
    // },
    // Threat palette shared with the .wwThreat pills in appStyle.css
    threatColor(level) {
      var key = String(level || "").toLowerCase();
      if (key === "high") return "#b3261e";
      if (key === "medium") return "#c9930a";
      if (key === "low") return "#22683a";
      return "#7a7a7a";
    },
    // Crisp SVG teardrop pin, tinted by threat level. Scales without blur and
    // keeps the map legible where the old raster pins overlapped.
    buildPin(item) {
      const color = this.threatColor(item.threatlevel);
      const pending = item.status === "Pending";
      return L.divIcon({
        className: "wwPinWrap" + (pending ? " wwPinWrap--pending" : ""),
        html:
          '<span class="wwPin">' +
          '<svg width="26" height="34" viewBox="0 0 26 34" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M13 0C5.82 0 0 5.82 0 13c0 9.2 11.13 19.86 12.3 20.95a1 1 0 0 0 1.4 0C14.87 32.86 26 22.2 26 13 26 5.82 20.18 0 13 0z" fill="' +
          color +
          '"/>' +
          '<circle cx="13" cy="12.6" r="4.6" fill="#fff"/>' +
          "</svg></span>",
        iconSize: [26, 34],
        iconAnchor: [13, 34],
        popupAnchor: [0, -32],
      });
    },
    popupHtml(item, lat, lng) {
      const animalName =
        item.animalId && item.animalId.name ? item.animalId.name : "Unknown Animal";
      const threat = item.threatlevel || "Unknown";
      const threatKey = String(threat).toLowerCase();
      const phone = item.contactNumber
        ? this.isDialable(item.contactNumber)
          ? '<a href="tel:' + item.contactNumber + '">' + item.contactNumber + "</a>"
          : item.contactNumber
        : "Not available";
      return (
        '<div class="wwPop">' +
        '<div class="wwPopHead">' +
        '<span class="wwPopTitle">' +
        animalName +
        "</span>" +
        '<span class="wwThreat wwThreat--' +
        (["low", "medium", "high"].indexOf(threatKey) > -1 ? threatKey : "unknown") +
        '">' +
        threat +
        "</span>" +
        "</div>" +
        '<div class="wwPopRows">' +
        this.popupRow("Location", item.locationname || "N/A") +
        this.popupRow("Status", item.status || "N/A") +
        this.popupRow("Phone", phone) +
        this.popupRow("Coords", lat.toFixed(5) + ", " + lng.toFixed(5)) +
        "</div>" +
        '<a class="wwPopBtn" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
        lat +
        "," +
        lng +
        '">Get Directions</a>' +
        "</div>"
      );
    },
    popupRow(label, value) {
      return (
        '<div class="wwPopRow"><span class="wwPopLabel">' +
        label +
        '</span><span class="wwPopValue">' +
        value +
        "</span></div>"
      );
    },
    initMap() {
      const mapCanvas = document.getElementById("map");
      if (!mapCanvas) return;

      // Rebuild from scratch on every refresh so stale markers cannot linger.
      if (this.map && this.map.remove) {
        this.map.remove();
      }
      this.markers = [];
      this.infowindows = [];

      const kerala = [10.8505, 76.2711];
      this.map = L.map(mapCanvas, {
        center: kerala,
        zoom: 7,
        zoomControl: false,
        attributionControl: true,
      });

      // Street map is the default view; labelled satellite is one click away.
      const streets = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        subdomains: "abc",
        maxZoom: 19,
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      const satellite = L.layerGroup([
          L.tileLayer(
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            { maxZoom: 19, attribution: "Tiles &copy; Esri" }
          ),
          // Place names and boundaries - the imagery layer has none.
          L.tileLayer(
            "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
            { maxZoom: 19, pane: "overlayPane", opacity: 0.9 }
          ),
        ]);

      L.control.zoom({ position: "topright" }).addTo(this.map);
      L.control
        .layers({ Map: streets, Satellite: satellite }, null, {
          position: "topright",
          collapsed: false,
        })
        .addTo(this.map);

      const points = [];

      this.caseDetails.forEach((item) => {
        if (!item.location || !Array.isArray(item.location) || item.location.length < 2)
          return;
        const lat = parseFloat(item.location[1]);
        const lng = parseFloat(item.location[0]);
        if (isNaN(lat) || isNaN(lng) || (lat === 0 && lng === 0)) return;

        const mapMarker = L.marker([lat, lng], {
          icon: this.buildPin(item),
          title: "Threat Level: " + (item.threatlevel || "Unknown"),
          riseOnHover: true,
        });
        mapMarker.bindPopup(this.popupHtml(item, lat, lng), {
          className: "wwPopupShell",
          minWidth: 250,
          maxWidth: 310,
          closeButton: true,
        });

        // Individual pins, no clustering — every case stays visible on the map.
        mapMarker.addTo(this.map);
        this.markers.push(mapMarker);
        points.push([lat, lng]);
      });

      if (points.length === 1) {
        this.map.setView(points[0], 12);
      } else if (points.length > 1) {
        this.map.fitBounds(L.latLngBounds(points), { padding: [40, 40] });
      }
    },
    timeSince(time) {
      switch (typeof time) {
        case "number":
          break;
        case "string":
          time = +new Date(time);
          break;
        case "object":
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      var time_formats = [
        [60, "seconds", 1], // 60
        [120, "1 minute ago", "1 minute from now"], // 60*2
        [3600, "minutes", 60], // 60*60, 60
        [7200, "1 hour ago", "1 hour from now"], // 60*60*2
        [86400, "hours", 3600], // 60*60*24, 60*60
        [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
        [604800, "days", 86400], // 60*60*24*7, 60*60*24
        [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
        [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
        [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
        [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
        [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      var seconds = (+new Date() - time) / 1000,
        token = "ago",
        list_choice = 1;

      if (seconds == 0) {
        return "Just now";
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "from now";
        list_choice = 2;
      }
      var i = 0,
        format;
      while ((format = time_formats[i++]))
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      return time;
    },
    deleteCase() {
      this.dialog = false;
      axios({
        method: "POST",
        url: "/report/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.caseToDelete,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            window.location.reload();
            // this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$emit("showSnackbar", "Error deleting case");
        });
    },
  },
};
</script>
<style>
.posSticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 15px;
}
/* Card / info-row / threat-pill styles live in assets/styles/appStyle.css
   so views/Admin/Cases/caseDetails.vue can share them. */
</style>
